<template>
  <main class="website-cms-shell">
    <PageHeader :icon="icon">
      <template #title>{{ title }}</template>
      <template #subtitle>{{ subtitle }}</template>
      <template #actions v-if="actionLabel">
        <b-button variant="primary" class="website-cms-action" @click="$emit('action')">
          <i class="fas fa-plus"></i>
          <span>{{ actionLabel }}</span>
        </b-button>
      </template>
    </PageHeader>

    <nav class="website-cms-nav" aria-label="Navigasi Website dan CMS">
      <router-link
        v-for="item in navigation"
        :key="item.to"
        :to="item.to"
        class="website-cms-nav__item"
        active-class="website-cms-nav__item--active"
      >
        <i :class="item.icon"></i>
        <span>{{ item.label }}</span>
      </router-link>
    </nav>

    <div class="website-cms-workspace" :class="{ 'website-cms-workspace--stacked': stacked || !$slots.editor }">
      <section class="website-cms-panel website-cms-panel--list">
        <header class="website-cms-panel__header">
          <div>
            <span class="website-cms-panel__eyebrow">{{ listEyebrow }}</span>
            <h2>{{ listTitle }}</h2>
            <p>{{ listDescription }}</p>
          </div>
          <span class="website-cms-panel__icon"><i class="fas fa-list-ul"></i></span>
        </header>
        <div class="website-cms-panel__body"><slot name="list" /></div>
      </section>

      <aside v-if="$slots.editor" class="website-cms-panel website-cms-panel--editor">
        <header class="website-cms-panel__header">
          <div>
            <span class="website-cms-panel__eyebrow">{{ editorEyebrow }}</span>
            <h2>{{ editorTitle }}</h2>
            <p>{{ editorDescription }}</p>
          </div>
          <span class="website-cms-panel__icon website-cms-panel__icon--teal"><i :class="editorIcon"></i></span>
        </header>
        <div class="website-cms-panel__body"><slot name="editor" /></div>
      </aside>
    </div>
  </main>
</template>

<script>
export default {
  name: "WebsiteCmsShell",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, required: true },
    icon: { type: String, default: "fas fa-globe" },
    actionLabel: { type: String, default: "" },
    listEyebrow: { type: String, default: "Konten website" },
    listTitle: { type: String, default: "Daftar konten" },
    listDescription: { type: String, default: "Kelola konten yang tampil pada website klinik." },
    editorEyebrow: { type: String, default: "Editor konten" },
    editorTitle: { type: String, default: "Tambah konten" },
    editorDescription: { type: String, default: "Lengkapi informasi konten lalu simpan perubahan." },
    editorIcon: { type: String, default: "fas fa-plus" },
    stacked: { type: Boolean, default: false },
  },
  data() {
    return {
      navigation: [
        { to: "/website/setting", label: "Setelan", icon: "fas fa-cog" },
        { to: "/website/slide", label: "Slide Banner", icon: "fas fa-images" },
        { to: "/website/service", label: "Layanan", icon: "fas fa-concierge-bell" },
        { to: "/website/posts", label: "Berita", icon: "fas fa-newspaper" },
        { to: "/website/post-category", label: "Kategori", icon: "fas fa-tags" },
        { to: "/website/doctor", label: "Dokter", icon: "fas fa-user-md" },
      ],
    };
  },
};
</script>

<style scoped>
.website-cms-shell { display: grid; gap: 18px; max-width: none; width: 100%; }
.website-cms-nav { background: #fff; border: 1px solid #e4ebf3; border-radius: 14px; display: flex; gap: 6px; overflow-x: auto; padding: 7px; scrollbar-width: thin; }
.website-cms-nav__item { align-items: center; border-radius: 10px; color: #60708a; display: inline-flex; flex: 0 0 auto; font-size: 13px; font-weight: 600; gap: 8px; min-height: 42px; padding: 0 16px; transition: .18s ease; }
.website-cms-nav__item:hover { background: #f0f8f8; color: #148c8a; text-decoration: none; }
.website-cms-nav__item--active { background: linear-gradient(135deg, #114b7a, #15978f); box-shadow: 0 6px 14px rgba(18, 103, 125, .2); color: #fff; }
.website-cms-nav__item--active:hover { color: #fff; }
.website-cms-workspace { align-items: start; display: grid; gap: 18px; grid-template-columns: minmax(0, 1.15fr) minmax(390px, .85fr); }
.website-cms-workspace--stacked { grid-template-columns: minmax(0, 1fr); }
.website-cms-panel { background: #fff; border: 1px solid #e4ebf3; border-radius: 16px; box-shadow: 0 8px 26px rgba(20, 50, 99, .055); min-width: 0; overflow: hidden; }
.website-cms-panel__header { align-items: flex-start; border-bottom: 1px solid #edf1f6; display: flex; justify-content: space-between; min-height: 98px; padding: 20px 22px 16px; }
.website-cms-panel__header h2 { color: #26354d; font-size: 18px; font-weight: 700; margin: 3px 0 4px; }
.website-cms-panel__header p { color: #7c899e; font-size: 12px; margin: 0; }
.website-cms-panel__eyebrow { color: #15978f; font-size: 10px; font-weight: 800; letter-spacing: .08em; text-transform: uppercase; }
.website-cms-panel__icon { align-items: center; background: #eef4fa; border-radius: 11px; color: #17638f; display: inline-flex; flex: 0 0 38px; height: 38px; justify-content: center; }
.website-cms-panel__icon--teal { background: #edf9f7; color: #15978f; }
.website-cms-panel__body { min-width: 0; padding: 18px; }
.website-cms-shell::v-deep .website-cms-action { align-items: center; background: linear-gradient(135deg, #14608f, #1e958f) !important; border: 0 !important; border-radius: 10px; box-shadow: 0 6px 16px rgba(30, 149, 143, .24); color: #fff !important; display: inline-flex; font-size: 13px; font-weight: 700; gap: 8px; justify-content: center; min-height: 42px; padding: 0 20px; }
.website-cms-shell::v-deep .website-cms-action i,
.website-cms-shell::v-deep .website-cms-action span { color: #fff !important; opacity: 1 !important; visibility: visible !important; }
.website-cms-shell::v-deep .website-cms-action:hover,
.website-cms-shell::v-deep .website-cms-action:focus { background: linear-gradient(135deg, #0f4c72, #187b76) !important; color: #fff !important; transform: translateY(-1px); }
@media (max-width: 1199.98px) { .website-cms-workspace { grid-template-columns: minmax(0, 1fr); } }
@media (max-width: 575.98px) { .website-cms-shell { gap: 12px; } .website-cms-nav { border-radius: 12px; } .website-cms-nav__item { padding: 0 13px; } .website-cms-panel__header { padding: 16px; } .website-cms-panel__body { padding: 12px; } }
</style>
